(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("jsnes", [], factory);
	else if(typeof exports === 'object')
		exports["jsnes"] = factory();
	else
		root["jsnes"] = factory();
})(this, () => {
return 